import { useMemo } from "react";
import {
  getGoogleMapLink,
  HotelNavigationUtility,
} from "@b2bportal/core-utilities";
import type { Reservation } from "@b2bportal/lodging-api";
import { HOTELS_SHOP_PATH } from "@/utilities/constants";

export const usePropertyDetails = (reservation: Reservation) => {
  return useMemo(() => {
    const lodgingData = reservation.lodgingData;
    if (lodgingData == null) return null;

    const address =
      typeof lodgingData.address === "string"
        ? lodgingData.address
        : [
            lodgingData.address?.line1,
            lodgingData.address?.line2,
            lodgingData.address?.city,
            lodgingData.address?.stateOrProvince,
            lodgingData.address?.postalCode,
          ]
            .filter(Boolean)
            .join(", ");

    const phone = lodgingData.phone ?? "";

    const mapsUrl =
      address !== ""
        ? getGoogleMapLink({
            placeName: lodgingData.name,
            address,
            coordinates: lodgingData.location?.coordinates,
          })
        : "";

    const lodgingId = lodgingData.id ?? "";

    const searchParams = HotelNavigationUtility.buildSearchParams({
      dateRange: {
        from: reservation.checkInDate,
        until: reservation.checkOutDate,
      },
      guests: {
        adults: reservation.adultCount,
        children: reservation.childrenAges,
      },
      roomsCount: reservation.bookedRooms?.length,
    });

    const shopUrl =
      lodgingId !== ""
        ? `${HOTELS_SHOP_PATH}/${lodgingId}?${searchParams.toString()}`
        : "";

    return {
      address,
      phone,
      mapsUrl,
      shopUrl,
    };
  }, [reservation]);
};
